import { HOMEOWNERS_INSURANCE_PREPAID_PATTERN } from '../../readiness/readinessChecks.constants';

export const INITIAL_LE_PACKAGE_NAME = 'Initial LE';

export const toPositiveNumber = value => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
};

export const resolveHasAppraisedValue = subjectProperty => {
  if (!subjectProperty || !Object.keys(subjectProperty).length) {
    return undefined;
  }

  const raw =
    subjectProperty.appraisedValue ??
    subjectProperty.propertyAndOccupancy?.appraisedValue ??
    subjectProperty.propertyValue;

  return (toPositiveNumber(raw) ?? 0) > 0;
};

export const resolveFees = feesView => {
  if (!feesView) {
    return { isLoaded: false };
  }

  const prepaidItems = feesView.main?.F?.items ?? [];
  const hasHomeownersInsurancePremium = prepaidItems.some(
    item =>
      HOMEOWNERS_INSURANCE_PREPAID_PATTERN.test(item?.name ?? '') &&
      (toPositiveNumber(item?.amount) ?? 0) > 0,
  );

  return { isLoaded: true, hasHomeownersInsurancePremium };
};
